<template>
  <div class="relative bg-neutral-50 dark:bg-neutral-800 w-full shadow-md">
    <div class="flex flex-wrap gap-2 items-center justify-center py-2 px-2 md:px-6">
      <template v-if="pageCount > 1">
        <div class="flex items-center justify-center dark:text-neutral-200">
          <span class="hidden md:inline-block">{{ $t('labels.page', 2) }}</span>
          <span class="md:hidden">Pág.</span>
          <span class="ml-1">{{ fPage }}/{{ pageCount || 0 }}</span>
        </div>
      </template>
      <div class="hidden md:block grow"></div>
      <slot name="actions"></slot>
      <div v-if="pageCount > 1 && !allPagesView" class="flex gap-2">
        <div class="tooltip tooltip-bottom" :data-tip="$t('button.firstPage', {text: '(Ctrl + ←)'})">
          <UiButton type="ghost" class="p-2 disabled:!bg-transparent" :disabled="fPage === 1" @click.stop.prevent="fPage = 1">
            <UiIcon icon="arrow-bar-to-left" />
          </UiButton>
        </div>
        <div class="tooltip tooltip-bottom" :data-tip="$t('labels.previousPage', {text: $t('button.press', {text: '←'})})">
          <UiButton type="ghost" class="p-2 disabled:!bg-transparent" :disabled="fPage === 1" @click.stop.prevent="fPage--">
            <UiIcon icon="arrow-left" />
          </UiButton>
        </div>
        <div class="tooltip tooltip-bottom" :data-tip="$t('button.nextPage', {text: $t('button.press', {text: '→'})})">
          <UiButton type="ghost" class="p-2 disabled:!bg-transparent" :disabled="fPage === pageCount" @click.stop.prevent="fPage++">
            <UiIcon icon="arrow-right" />
          </UiButton>
        </div>
        <div class="tooltip tooltip-bottom" :data-tip="$t('button.lastPageViewed', {text: '(Ctrl + →)'})">
          <UiButton type="ghost" class="p-2 disabled:!bg-transparent" :disabled="fPage === maxPage" @click.stop.prevent="fPage =  props.maxPage">
            <UiIcon icon="arrow-bar-to-right" />
          </UiButton>
        </div>
      </div>
    </div>
    <div>
      <div class="absolute bottom-0 left-0 h-0.5 block bg-[--c-primary-400] transition-all" :style="{ width: `${pageProgress}%` }"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { clamp } from '@/common/util'
import UiButton from '@/components/ui/button.vue'
import UiIcon from '@/components/ui/icon.vue'

const props = defineProps<{
  modelValue: number
  pageCount: number
  maxPage?: number
  allPagesView?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const fPage = computed({
  get: () => props.modelValue || 0,
  set: (v) => emit('update:modelValue', clamp(v, 1, props.pageCount))
})

const pageProgress = computed(() => {
  if (!props.pageCount) return 0
  return ((props.modelValue - 1) * 100) / (props.pageCount - 1)
})

defineExpose({
  lastPage: () => fPage.value =  props.maxPage,
  firstPage: () => fPage.value = 1,
  previousPage: () => fPage.value !== 1 && (fPage.value--),
  nextPage: () => fPage.value !== props.pageCount && (fPage.value++),
})
</script>
